import React, { useState, useContext } from 'react';

import ButtonBack from '../../../components/button/ButtonBack'
import ButtonNext from '../../../components/button/ButtonWhite'
import ButtonStepReview from '../../../components/button/ButtonStepReview'

import { ReactComponent as BACK } from '../../../assets/IconsColurs/IconsGeneral/chevronLeft.svg';
import { ReactComponent as NEXT } from '../../../assets/IconsColurs/IconsGeneral/chevronRight.svg';

import { UtilContext } from "../../../context/UtilContext";
import { GLOBAL_LANGUAGE } from "../../../language/language";


const Step7 = ({ onClick, totalCompany, companyPending, userlevel, setPaso, onClickBack, onClickPaso4, onClickPaso3, loading, LoadingBack }) => {


    const { language } = useContext(UtilContext); // Usa el contexto de Auth
    const t = GLOBAL_LANGUAGE[language] || GLOBAL_LANGUAGE.es;

    const [textFondos, setTextFondos] = useState('')
    const [isNaturalPerson, setIsNaturalPerson] = useState(true);
    const [isPep, setIsPep] = useState(false);
    return (
        <div className="w-full h-fit pb-16"  >
            <div className='gap-2 flex flex-col ' >
                <p className=" text-2xl mt-8 " style={{ fontFamily: "brico" }} >
                    {t.steps7.title}
                </p>
                <p className='text-[#8A8A8E]' >{t.steps7.description}</p>
            </div>
            <div className='gap-2 mt-10 flex flex-col ' >

                <ButtonStepReview check={true} label={t.steps7.label_button1} />
                <ButtonStepReview check={true} label={t.steps7.label_button2} />
                <ButtonStepReview check={true} label={t.steps7.label_button3} />
                <ButtonStepReview check={true} label={t.steps7.label_button4} />
                <ButtonStepReview check={true} label={t.steps7.label_button5} />
                <ButtonStepReview check={true} label={t.steps7.label_button6} />
                <ButtonStepReview completedTasks={userlevel === 5 ? 1 : 0} totalTasks={userlevel === null ? null : 1} label={t.steps7.label_button7} onClick={onClickPaso3} />
                <ButtonStepReview completedTasks={totalCompany} totalTasks={companyPending} label={t.steps7.label_button8} onClick={onClickPaso4} />
            </div>

            <div>
            </div>
            <div className='flex justify-between w-full mt-10' >
                <ButtonBack label={t.steps7.label_button_back} Icon={BACK} onClick={onClickBack} loading={LoadingBack} />
                <ButtonNext label={t.steps7.label_button_next} Icon={NEXT} onClick={onClick} loading={loading} />
            </div>
        </div >

    );
};

export default Step7;

